module.exports = __webpack_public_path__ + "img/case2.404040fc.jpg";